import { ApplicationState, AppThunkDispatch } from "../store";
import { connect } from "react-redux";
import ReportForm  from "../components/Forms/ReportForm";
import { ReportEntity } from "../store/entities/state";
import { getChangingValue } from "../store/entities/selectors";
import { copyOpenReport, entityCreatingCancel, updateChangingEntity } from "../store/entities/actions";
import { ReportFormDispatchProps, ReportFormStateProps } from "../components/Forms/ReportForm";
import { getCompanyLogo } from "../store/settings/selectors";

const mapStateToProps = (state: ApplicationState): ReportFormStateProps => ({
    companyLogo: getCompanyLogo(state),
    report: getChangingValue(state, 'reports') as ReportEntity,
    readOnly: true,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch): ReportFormDispatchProps => ({
    onChange: (data: ReportEntity) => dispatch(updateChangingEntity('reports', data)),
    onClose: () => dispatch(entityCreatingCancel('reports')),
    onCopy: (data: Record<string, string>) => dispatch(copyOpenReport(data))
});

const ReportViewForm = connect<ReportFormStateProps, ReportFormDispatchProps, unknown, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ReportForm as any);

export default ReportViewForm;